export const environment = {
  production: false,
  firebase: {
    // apiKey: 'AIzaSyBMfpj0MLL7-oI8_QnRR7X97ZOzrtFPlBA',
    // authDomain: 'conference-alpha.firebaseapp.com',
    // databaseURL: 'https://conference-alpha.firebaseio.com',
    // projectId: 'conference-alpha',
    // storageBucket: 'conference-alpha.appspot.com',
    // messagingSenderId: '143545011016',

    // alpha deployment
    // apiKey: "AIzaSyAE5D4i1__q7IZyQfen6hYIiR1x3Wb2H2g",
    // authDomain: "tbevents-conference-alpha.firebaseapp.com",
    // databaseURL: "https://tbevents-conference-alpha.firebaseio.com",
    // projectId: "tbevents-conference-alpha",
    // storageBucket: "tbevents-conference-alpha.appspot.com",
    // messagingSenderId: "992996215144",
    // appId: "1:992996215144:web:6be502ea257c97b8",
    // measurementId: "G-JS7LY60084"

    // beta deployment
    apiKey: "AIzaSyDcRAATWD0PlmKJXnmudgg9SgohsjOgOYw",
    authDomain: "tbevents-conference-beta.firebaseapp.com",
    databaseURL: "https://tbevents-conference-beta-default-rtdb.firebaseio.com",
    projectId: "tbevents-conference-beta",
    storageBucket: "tbevents-conference-beta.appspot.com",
    messagingSenderId: "782113262453",
    appId: "1:782113262453:web:b3ea0b562672fb1727a13c",
    measurementId: "G-8C697Y3MFN"
  },
};



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/environments/environment.ts